import { Salutation } from '../enums/salutation.enum';

export class User {
    id: string;
    username: string;
    mailaddress: string;
    password: string;
    firstname: string;
    lastname: string;
    lastLogin: string;
    salutation: Salutation;
    street: string;
    city: string;
    zipCode: string;
    country: string;
    telephone: string;
    mobile: string;
    groupId: string;
    groupName: string;
   constructor() {
   }
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts